export default __webpack_public_path__ + "static/media/register.a09e80e3.jpg";